import Vue from 'vue';

Vue.component('vuetable-drawer-check', () =>
    import(/* webpackChunkName: 'drawer-check-index' */ './vuetable-drawer-check.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/drawer-check/index.js